import React from "react";
import Typewriter from "typewriter-effect";
import myImg from "../../Assets/shanto_avatar.jpg";
import pdf from "../../Assets/shanto_cv.pdf";
import { AiFillGithub, AiFillFacebook } from "react-icons/ai";
import { FaLinkedinIn, FaGooglePlay, FaDownload } from "react-icons/fa";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: "smooth" });
};

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      {/* BG orbs */}
      <div className="hero-bg-orb hero-bg-orb-1" />
      <div className="hero-bg-orb hero-bg-orb-2" />
      <div className="hero-bg-orb hero-bg-orb-3" />

      <div className="hero-grid">
        {/* ── Left ── */}
        <div className="hero-left">
          <div className="hero-badge fade-in-up delay-1">
            <span className="badge-dot" />
            Open to work &amp; collaboration
          </div>

          <p className="hero-greeting fade-in-up delay-2">
            Hi there! <span className="wave">👋</span>
          </p>

          <h1 className="hero-name fade-in-up delay-3">
            I'M{" "}
            <span className="gradient-text">SAKIB AHMED SHANTO</span>
          </h1>

          <div className="hero-type-wrapper fade-in-up delay-4">
            <Typewriter
              options={{
                strings: [
                  "Flutter & Mobile Developer",
                  "iOS & Android App Publisher",
                  "App Store & Play Store Expert",
                  "Firebase & Cloud Specialist",
                  "ARCore & IoT Builder",
                  "Hackathon Champion 🏆",
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 40,
                delay: 55,
              }}
            />
          </div>

          {/* Stats */}
          <div className="hero-stats fade-in-up delay-5">
            <div className="stat-item">
              <span className="stat-number">4K+</span>
              <span className="stat-label">Downloads</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-number">2+</span>
              <span className="stat-label">Yrs Exp</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-number">5+</span>
              <span className="stat-label">Live Apps</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-number">4.2★</span>
              <span className="stat-label">Play Rating</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="hero-cta fade-in-up delay-6">
            <button className="btn-primary-hero" onClick={() => scrollTo("projects")}>
              View Projects
            </button>
            <a href={pdf} target="_blank" rel="noreferrer" className="btn-secondary-hero">
              <FaDownload /> Download CV
            </a>
          </div>

          {/* Socials */}
          <div className="hero-social fade-in-up delay-7">
            <a href="https://github.com/sakibahmedshanto"            target="_blank" rel="noreferrer" className="social-link" title="GitHub">  <AiFillGithub /></a>
            <a href="https://www.linkedin.com/in/sakibsanto/"         target="_blank" rel="noreferrer" className="social-link" title="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://play.google.com/store/apps/developer?id=ahmedapps" target="_blank" rel="noreferrer" className="social-link" title="Play Store"><FaGooglePlay /></a>
            <a href="https://www.facebook.com/sakib.ahmed.shanto.910428/" target="_blank" rel="noreferrer" className="social-link" title="Facebook"><AiFillFacebook /></a>
          </div>
        </div>

        {/* ── Right: Avatar ── */}
        <div className="hero-avatar-wrapper fade-in-left delay-3">
          <div className="avatar-container">
            <div className="avatar-glow" />
            <div className="avatar-ring-outer" />
            <img src={myImg} alt="Sakib Ahmed Shanto" className="avatar-image" />
            <div className="floating-badge badge-flutter">📱 Flutter Dev</div>
            <div className="floating-badge badge-store">🍎 App Store Live</div>
            <div className="floating-badge badge-iot">🤖 ARCore</div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <button className="scroll-indicator" onClick={() => scrollTo("about")} style={{ background: "none", border: "none", cursor: "pointer" }}>
        <div className="scroll-mouse" />
        <span>Scroll to explore</span>
      </button>
    </section>
  );
}

export default HeroSection;
